import routesConfig from "./routesConfig";
import Permissions from "./permissions";

export default {
  menus: [
    {
      key: " dashboard",
      title: "Dashboard",
      permissions: [],
      route: null,
      iconClass: "ion ion-ios-home-outline",
      subMenus: null,
    },
    {
      key: "disputeManagement",
      title: "Dispute Management",
      permissions: [Permissions.VIEW_DISPUTE],
      route: null,
      iconClass: "ion ion-ios-briefcase-outline",
      subMenus: [
        {
          key: "newDispute",
          title: "New Dispute",
          permissions: [Permissions.CREATE_DISPUTE],
          route: routesConfig.NEW_CLAIM_ROUTE,
        },
        {
          key: "bulkDisputes",
          title: "Dispute Batches",
          permissions: [Permissions.CREATE_DISPUTE, Permissions.VIEW_DISPUTE],
          route: routesConfig.BULK_DISPUTES_ROUTE,
        },
        {
          key: "dispute",
          title: "Disputes",
          permissions: [Permissions.VIEW_DISPUTE],
          route: routesConfig.DISPUTES_ROUTE,
        },
        {
          key: "disputeBulkAccept",
          title: "Bulk Updates",
          permissions: [Permissions.VIEW_DISPUTE],
          route: routesConfig.DISPUTE_BULK_ACCEPT_ROUTE,
        },
        {
          key: "disputeBulkAcceptStatus",
          title: "Bulk Updates Status",
          permissions: [Permissions.VIEW_DISPUTE],
          route: routesConfig.DISPUTE_UPDATE_STATUS_ROUTE,
        },
      ],
    },
    {
      key: "disputeManagementDiscover",
      title: "Discover Case Management",
      permissions: [Permissions.VIEW_DISPUTE],
      route: null,
      iconClass: "ion ion-android-globe",
      subMenus: [
        {
          key: "newDiscoverCase",
          title: "Create New Case",
          permissions: [Permissions.CREATE_DISPUTE],
          route: routesConfig.DISCOVER_TRANSACTIONS_ROUTE,
        },
        {
          key: "caseRequests",
          title: "Case Requests",
          permissions: [Permissions.VIEW_DISPUTE],
          route: routesConfig.DISCOVER_CASESREQUEST_ROUTE,
        },
        {
          key: "discoverCases",
          title: "Manage Cases",
          permissions: [Permissions.VIEW_DISPUTE],
          route: routesConfig.DISCOVER_CASES_ROUTE,
        },
      ],
    },
    {
      key: "settlementManagement",
      title: "Settlement Management",
      permissions: [
        Permissions.VIEW_SETTLEMENT,
        Permissions.VIEW_SETTLEMENT_REQUEST,
        Permissions.VIEW_SETTLEMENT_RULE,
        Permissions.VIEW_SETTLEMENT_REPORT,
      ],
      route: null,
      iconClass: "ion ion-folder",
      subMenus: [
        {
          key: "settlementRequests",
          title: "Requests",
          permissions: [Permissions.VIEW_SETTLEMENT_REQUEST],
          route: routesConfig.SETTLEMENT_REQUEST_ROUTE,
        },
        {
          key: "settlements",
          title: "Settlements",
          permissions: [Permissions.VIEW_SETTLEMENT],
          route: routesConfig.SETTLEMENT_ROUTE,
        },
        /* {
          key: "settlementReports",
          title: "Reports",
          permissions: [Permissions.VIEW_SETTLEMENT_REPORT],
          route: routesConfig.SETTLEMENT_REPORTS_ROUTES
        } */
      ],
    },
    {
      key: "systemManagement",
      title: "System Management",
      permissions: [
        Permissions.VIEW_SCRIPT,
        Permissions.VIEW_REASON_CODE,
        Permissions.VIEW_DISPUTE_REGION,
        Permissions.VIEW_TRANSACTION_GROUP,
        Permissions.VIEW_TRANSACTION_TYPE,
        Permissions.VIEW_TRANSACTION_TIMELINE,
        Permissions.VIEW_DISPUTE_TIMELINE,
        Permissions.VIEW_MERCHANT_DISPUTANT,
      ],
      route: null,
      iconClass: "ion ion-ios-cog-outline",
      subMenus: [
        {
          key: "disputeRegions",
          title: "Dispute Regions",
          permissions: [Permissions.VIEW_DISPUTE_REGION],
          route: routesConfig.DISPUTE_REGIONS_ROUTE,
        },
        {
          key: "disputeTimelines",
          title: "Dispute Timelines",
          permissions: [Permissions.VIEW_DISPUTE_TIMELINE],
          route: routesConfig.DISPUTE_TIMELINE_ROUTE,
        },

        {
          key: "merchantDisputants",
          title: "Merchant Disputants",
          permissions: [Permissions.VIEW_MERCHANT_DISPUTANT],
          route: routesConfig.MERCHANT_DISPUTANT_ROUTE,
        },
        {
          key: "settingsConfig",
          title: "Settings Configuration",
          permissions: [Permissions.VIEW_MERCHANT_DISPUTANT],
          route: routesConfig.SETTINGS_CONFIG_ROUTE,
        },

        {
          key: "settlementRules",
          title: "Settlement Rules",
          permissions: [Permissions.VIEW_SETTLEMENT_RULE],
          route: routesConfig.SETTLEMENT_RULES_ROUTE,
        },
        {
          key: "reasonCodes",
          title: "Reason Codes",
          permissions: [Permissions.VIEW_REASON_CODE],
          route: routesConfig.REASON_CODES_ROUTE,
        },
        {
          key: "scripts",
          title: "Scripts",
          permissions: [Permissions.VIEW_SCRIPT],
          route: routesConfig.SCRIPTS_ROUTE,
        },
        {
          key: "transactionGroups",
          title: "Transaction Groups",
          permissions: [Permissions.VIEW_TRANSACTION_GROUP],
          route: routesConfig.TRANSACTION_GROUPS_ROUTE,
        },
        {
          key: "transactionTimelines",
          title: "Transaction Timelines",
          permissions: [Permissions.VIEW_TRANSACTION_TIMELINE],
          route: routesConfig.TRANSACTION_TIMELINE_ROUTE,
        },
        {
          key: "transactionTypes",
          title: "Transaction Types",
          permissions: [Permissions.VIEW_TRANSACTION_TYPE],
          route: routesConfig.TRANSACTION_TYPES_ROUTE,
        },
      ],
    },
    {
      key: "reports",
      title: "Reports",
      permissions: [Permissions.VIEW_SETTLEMENT_REPORT],
      route: routesConfig.REPORTS_ROUTE,
      iconClass: "ion ion-ios-paper",
    },
    {
      key: "help",
      title: "Help",
      permissions: [Permissions.VIEW_DISPUTE],
      iconClass: "ion ion-information-circled",
      subMenus: [
        {
          key: "userGuide",
          title: "User Guide",
          permissions: [Permissions.VIEW_DISPUTE],
          route: routesConfig.USER_GUIDE_ROUTE,
        },
        {
          key: "faq",
          title: "FAQs",
          permissions: [Permissions.VIEW_DISPUTE],
          route: routesConfig.FAQ_ROUTE,
        },
        {
          key: "customerPortal",
          title: "Customer Portal",
          permissions: [Permissions.VIEW_DISPUTE],
          route: routesConfig.CUSTOMER_PORTAL_ROUTE,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/configurations/menuConfig.js